import { SuggestedExchangeEventType } from "@redotech/redo-model/return-flow/suggested-exchange-events";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const updateAiExchangeRecommendations = {
  name: "updateAiExchangeRecommendations" as const,
  input: z.object({
    draftReturnId: zExt.objectId(),
    returnableItemId: z.string(),
    productId: z.string(),
    recommendationType: z.nativeEnum(SuggestedExchangeEventType),
    recommendations: z.array(
      z.object({
        productId: z.string(),
        variantId: z.string(),
        productTitle: z.string(),
        variantTitle: z.string(),
        rank: z.number(),
        explanation: z.string(),
      }),
    ),
  }),
  output: z.object({ success: z.boolean() }),
};
